// src/pages/CreateUserForm.jsx
import React, { useState } from "react";
import { Form, Input, Button, Select, message } from "antd";
import { createUser } from "../api/userApi";
import { useAuth } from "../context/AuthContext";

const { Option } = Select;

const CreateUserForm = ({ onSuccess, onCancel }) => {
  const { role: currentUserRole } = useAuth();
  const [role, setRole] = useState("CLIENT_USER");
  const [loading, setLoading] = useState(false);

  const handleRoleChange = (value) => {
    setRole(value);
  };

  const onFinish = async (values) => {
    setLoading(true);
    try {
      const userData = { ...values, role };
      await createUser(userData);
      message.success("¡Usuario creado exitosamente!");
      onSuccess(); // Notificar al componente padre para refrescar la lista y cerrar el modal
    } catch (error) {
      console.error("Error creating user:", error);
      message.error("Error al crear el usuario");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ maxWidth: 400 }}>
      <h3>Crear Nuevo Usuario</h3>
      <Form layout="vertical" onFinish={onFinish}>
        <Form.Item
          label="Nombre"
          name="name"
          rules={[
            { required: true, message: "Ingresa el nombre" },
            { min: 3, message: "El nombre debe tener al menos 3 caracteres" },
          ]}
        >
          <Input />
        </Form.Item>
        <Form.Item
          label="Email"
          name="email"
          rules={[
            { required: true, message: "Ingresa el email" },
            { type: "email", message: "Email inválido" },
          ]}
        >
          <Input />
        </Form.Item>
        <Form.Item
          label="Contraseña"
          name="password"
          rules={[
            { required: true, message: "Ingresa la contraseña" },
            {
              min: 8,
              message: "La contraseña debe tener al menos 8 caracteres",
            },
            {
              pattern: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[\W]).+$/,
              message:
                "La contraseña debe contener al menos una letra minúscula, una letra mayúscula, un número y un carácter especial",
            },
          ]}
        >
          <Input.Password />
        </Form.Item>
        <Form.Item label="Rol" name="role" initialValue="CLIENT_USER">
          <Select placeholder="Selecciona un rol" onChange={handleRoleChange}>
            {currentUserRole === "ADMIN" && (
              <Option value="ADMIN">ADMIN</Option>
            )}
            <Option value="CLIENT_ADMIN">CLIENT_ADMIN</Option>
            <Option value="CLIENT_USER">CLIENT_USER</Option>
          </Select>
        </Form.Item>
        <Form.Item>
          <Button type="primary" htmlType="submit" loading={loading}>
            Crear
          </Button>
          <Button onClick={onCancel} style={{ marginLeft: 8 }}>
            Cancelar
          </Button>
        </Form.Item>
      </Form>
    </div>
  );
};

export default CreateUserForm;
